import { CSSProperties } from 'react'
import { Switch, Route, useLocation } from 'react-router-dom'
import useScreen from 'Hooks/useScreen';
import { styx } from 'modules/Utils';
import HomePage from 'pages/HomePage';
import Colors from 'modules/Colors';
import MarketingCampaignDetails from 'pages/MarketingCampaignDetails/MarketingCampaignDetails';
import Navbar from 'components/Navbar/Navbar';

const PublicRoutes = () => {
    const location = useLocation();
    const {
        cssCalc
    } = useScreen();

    const getFlexDirection = () => {
        if (location.pathname.includes('/adbox/campaigns/')) {
            return 'row';
        }
        return 'column';
    }

    const hasNavbar = location.pathname.includes('/adbox/campaigns/');

    return (
        <div
            className="publicRoutesComponent"
            style={styx(
                sty.publicRoutesComponent,
                { flexDirection: getFlexDirection() },
                {
                    height: cssCalc()
                }
            )}
        >
            {hasNavbar && <Navbar className="navbarFromPublicRoutes" isPublic />}
            <Switch>
                <Route
                    exact
                    path="/homepage"
                    children={<HomePage />}
                />
                <Route
                    exact
                    path="/adbox/campaigns/:campaignId"
                    children={
                        <MarketingCampaignDetails
                            className="marketingCampaignDetailsComponentPublic"
                            style={{
                                position: 'relative',
                            }}
                            isPublic
                        />
                    }
                />
            </Switch>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    publicRoutesComponent: {
        display: 'flex',
        width: '100%',
    }
}

export default PublicRoutes;